import { RouteRecordRaw } from 'vue-router';

import { ROLES, TRole } from '@/constants/roles';
import { useUserDataStore } from '@/stores/UserData';

import { BUSINESS } from './onboarding-business';
import { PERSONAL } from './onboarding-personal';
import { SOLE_TRADER } from './onboarding-sole-trader';

export const ONBOARDING: RouteRecordRaw = {
  path: '/onboarding',
  name: 'onboarding',
  children: [PERSONAL, BUSINESS, SOLE_TRADER],
  redirect: () => {
    if ([
      ROLES.individual_onboarding_2,
      ROLES.individual_onboarding_3,
    ].includes(useUserDataStore().role as TRole)) return PERSONAL;
    if ([
      ROLES.sole_trader_onboarding_2,
      ROLES.sole_trader_onboarding_3,
    ].includes(useUserDataStore().role as TRole)) return SOLE_TRADER;
    return BUSINESS;
  },
};
